import React, { useMemo } from 'react'
import NewWedingModal from './NewWedingModal'
import styles from './NewWedingModal.module.scss'
import ButtonCustom from '../../../components/atoms/button/ButtonCustom'
import Stepper from '../../../components/atoms/Stepper/Stepper'
import VenuesSelectionCard from '../../../components/UserDashboard/VenuesSelectionCard/VenuesSelectionCard'

const images = [
  { src: '/images/ceremonyvibe/otb_onboarding_wedding_ceremony_vibe.png', title: 'Rustic Outdoor Ceremony' },
  { src: '/images/ceremonyvibe/otb_onboarding_wedding_ceremony_vibe_02.png', title: 'Wildflower Ring Nest Display' },
  { src: '/images/ceremonyvibe/otb_onboarding_wedding_ceremony_vibe_03.png', title: 'DIY Tin-Can DÃ©cor' },
  { src: '/images/ceremonyvibe/otb_onboarding_wedding_ceremony_vibe_04.png', title: 'Romantic Beach Floral Aisle' },
  { src: '/images/ceremonyvibe/otb_onboarding_wedding_ceremony_vibe_05.png', title: 'Tropical Seaside Wedding Path' },
  { src: '/images/ceremonyvibe/otb_onboarding_wedding_ceremony_vibe_06.png', title: 'Elegant Indoor Greenery Aisle' },
  { src: '/images/ceremonyvibe/otb_onboarding_wedding_ceremony_vibe_07.png', title: 'Ornate Cultural Ring Display' },
  { src: '/images/ceremonyvibe/otb_onboarding_wedding_ceremony_vibe_08.png', title: 'Olive Tree Garden Celebration' },
  { src: '/images/ceremonyvibe/otb_onboarding_wedding_ceremony_vibe_09.png', title: 'Burlap Aisle Wildflower Setup' },
  { src: '/images/ceremonyvibe/otb_onboarding_wedding_ceremony_vibe_10.png', title: 'Minimal Outdoor Burlap Drapes' },
  { src: '/images/ceremonyvibe/otb_onboarding_wedding_ceremony_vibe_11.png', title: 'Petal Confetti Seat Decor' },
  { src: '/images/ceremonyvibe/otb_onboarding_wedding_ceremony_vibe_12.png', title: 'Newlyweds Church Exit Moment' },
  { src: '/images/ceremonyvibe/otb_onboarding_wedding_ceremony_vibe_13.png', title: 'Barn Wedding Daisy Aisle' },
  { src: '/images/ceremonyvibe/otb_onboarding_wedding_ceremony_vibe_14.png', title: 'Pampas Lounge Boho Setup' },
  { src: '/images/ceremonyvibe/otb_onboarding_wedding_ceremony_vibe_15.png', title: 'Boho Rattan Chair Setup' },
  { src: '/images/ceremonyvibe/otb_onboarding_wedding_ceremony_vibe_16.png', title: 'Pampas Arch Beach Vows' },
  { src: '/images/ceremonyvibe/otb_onboarding_wedding_ceremony_vibe_17.png', title: 'Covered Modern Ceremony Space' },
  { src: '/images/ceremonyvibe/otb_onboarding_wedding_ceremony_vibe_18.png', title: 'Elderly Couple Vow Renewal' },
  { src: '/images/ceremonyvibe/otb_onboarding_wedding_ceremony_vibe_19.png', title: 'Henna Gold Ring Exchange' },
  { src: '/images/ceremonyvibe/otb_onboarding_wedding_ceremony_vibe_20.png', title: 'Clock Tower Wedding Portrait' },
  { src: '/images/ceremonyvibe/otb_onboarding_wedding_ceremony_vibe_21.png', title: 'Cultural Wedding Celebration' },
  { src: '/images/ceremonyvibe/otb_onboarding_wedding_ceremony_vibe_22.png', title: 'Greenhouse Wedding Portrait' },
  { src: '/images/ceremonyvibe/otb_onboarding_wedding_ceremony_vibe_23.png', title: 'White Arch Floral Portrait' },
  { src: '/images/ceremonyvibe/otb_onboarding_wedding_ceremony_vibe_24.png', title: 'Oceanfront Floral Ring Setup' },
  { src: '/images/ceremonyvibe/otb_onboarding_wedding_ceremony_vibe_25.png', title: 'Lakeside Rustic Arch' },
  { src: '/images/ceremonyvibe/otb_onboarding_wedding_ceremony_vibe_26.png', title: 'Outdoor Lakeside Seating' },
  { src: '/images/ceremonyvibe/otb_onboarding_wedding_ceremony_vibe_27.png', title: 'Indoor Intimate Ceremony' },
  { src: '/images/ceremonyvibe/otb_onboarding_wedding_ceremony_vibe_28.png', title: 'Prayer Moment at Altar' },
  { src: '/images/ceremonyvibe/otb_onboarding_wedding_ceremony_vibe_29.png', title: 'Castle Wedding with Car' },
  { src: '/images/ceremonyvibe/otb_onboarding_wedding_ceremony_vibe_30.png', title: 'Cathedral Ceremony Portrait' },
  { src: '/images/ceremonyvibe/otb_onboarding_wedding_ceremony_vibe_31.png', title: 'Sunlit Indoor Ceremony' },
  { src: '/images/ceremonyvibe/otb_onboarding_wedding_ceremony_vibe_32.png', title: 'Evening Terrace Floral Arch' },
]

function CeremonyVibe({
  open,
  handleClose,
  handleNext,
  handleBack,
  weddingData,
  setWeddingData,
}) {

  const imageByTitle = useMemo(
    () => Object.fromEntries(images.map((i) => [i.title, i.src])),
    []
  )

  const toggleSelect = (title) => {
  setWeddingData((prev) => {
    const isSelected = prev.ceremonyVibe.includes(title)
    const nextCeremonyVibe = isSelected
      ? prev.ceremonyVibe.filter((t) => t !== title)
      : [...prev.ceremonyVibe, title]

    const src = imageByTitle[title]
    const currentImgs = prev.selectedImages || []
    const nextSelectedImages = src
      ? (isSelected ? currentImgs.filter((p) => p !== src) : [...currentImgs, src])
      : currentImgs

    return {
      ...prev,
      ceremonyVibe: nextCeremonyVibe,
      selectedImages: nextSelectedImages,
    }
  })
}

  const handleNextAndSave = async () => {
    try {
      const selectedPaths = (weddingData.ceremonyVibe || []).map(
        (title) => imageByTitle[title]
      );

      setWeddingData((prev) => ({
          ...prev,
          ceremonyVibeImages: selectedPaths, 
      }));

      handleNext(weddingData.reception ? 1 : 4)
    } catch (e) {
      console.error('Failed to prep ceremony vibe images:', e?.message)
      handleNext(weddingData.reception ? 1 : 4)
    }
  }

  return (
    <NewWedingModal open={open} handleClose={handleClose} handleBack={() => handleBack(2)}>
      <div className={`${styles.welcomeModal}`}>
        <div className={styles.welcomeModalBody}>
          <h2>What's your ceremony vibe?</h2>
          <p>Select all the photos that contribute to your dream vision</p>
          <div style={{ width: '100%', marginTop: '40px' }}>
            <div className={styles.VenuesSelectionImages}>
              {images.map((item, index) => (
                <VenuesSelectionCard
                  key={index}
                  image={item.src}
                  title={item.title}
                  selected={weddingData.ceremonyVibe.includes(item.title)}
                  onClick={() => toggleSelect(item.title)}
                />
              ))}
            </div>
          </div>
        </div>
        <div className={`${styles.buttonContainer} ${styles.buttonContainerCenter}`}>
          <Stepper activeStep={2} />
          <ButtonCustom size="lg" data-cy="wizard-next" onClick={handleNextAndSave}>
            Next
          </ButtonCustom>
        </div>
      </div>
    </NewWedingModal>
  )
}

export default CeremonyVibe
